import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Container} from 'semantic-ui-react';
import _ from 'lodash';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import FemaLandingPage from 'go/pages/home/femaLandingPage';
import NonFemaLandingPage from 'go/pages/home/nonFemaLandingPage';
import ProfileUpdateModal from 'go/components/profile/profileUpdateModal';
import {isFemaOrProgramExternal, isFemaUser} from 'common/utils';
import {getRolesFromPermissions} from 'go/constants/roleFriendlyNameMappings';
import {getProgramNamesFromPermissions} from 'go/constants/programFriendlyMapping';

export class Home extends Component {
  render() {
    const {enterBy, permissions, displayName, jwt, toggles} = this.props;
    const appDevAndSubToggle = _.includes(this.props.toggles, 'appDevAndSub1-1');
    const loginGovIntegration = _.includes(this.props, toggles, 'loginGovIntegration');
    return (
      <Main>
        <Container
          fluid={appDevAndSubToggle}
          style={appDevAndSubToggle ? {padding: '26px 21px 0 21px'} : {}}
        >
          {loginGovIntegration && <ProfileUpdateModal />}
          {isFemaOrProgramExternal(permissions) || enterBy === 'FEMA APS' ? (
            <FemaLandingPage
              jwt={jwt}
              permissions={this.props.permissions}
              toggles={toggles}
            />
          ) : (
            <NonFemaLandingPage
              enterBy={enterBy}
              displayName={displayName}
              jwt={jwt}
              permissions={this.props.permissions}
              toggles={toggles}
            />
          )}
        </Container>
      </Main>
    );
  }
}

export const mapStateToProps = (state) => {
  if (
    !_.isEmpty(_.get(window, 'DD_RUM')) &&
    typeof window.DD_RUM.getUser === 'function'
  ) {
    let ddUser = window.DD_RUM.getUser();
    let user = {
      id: _.get(state, 'auth.userId'),
      name: _.get(state, 'profile.firstName') + ' ' + _.get(state, 'profile.lastName'),
      email: _.get(state, 'profile.emailAdr'),
      roles: getRolesFromPermissions(_.get(state, 'auth.permissions')).join(','),
      programs: getProgramNamesFromPermissions(_.get(state, 'auth.permissions')).join(
        ','
      ),
    };
    if (!_.isEqual(user, ddUser)) {
      window.DD_RUM.setUser(user);
    }
  }

  return {
    displayName: state.profile.firstName,
    jwt: state.auth.token,
    enterBy: state.profile.enteredBy,
    permissions: state.auth.permissions,
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, null)(Home);
